import { app } from "js/namespaces";
import { ds } from "js/core/models/dataService";
import { SideBar } from "js/editor/ui";
import { SideBarCanvasModifier } from "common/constants";
import { AnimationPanel } from "js/react/views/AnimationPanelOld/AnimationPanel";
import renderReactRoot from "js/react/renderReactRoot";
import { Key } from "js/core/utilities/keys";

export const AnimationDialog = SideBar.extend({
    fullScreen: false,
    className: "animation-dialog",
    type: "AnimationDialog",
    preventCanvasEditingWhenOpen: false,
    isResizable: true,
    showHeader: false,

    initialize: function({ editor, isReadOnly = false }) {
        SideBar.prototype.initialize.call(this, {});

        this.isReadOnly = isReadOnly;
        this.editor = editor;
    },

    getPanelHeight: function() {
        return 300;
    },

    getCanvasModifier: function() {
        return SideBarCanvasModifier.SCALE;
    },

    setup: function() {
        this.listenTo(ds.selection, "change:slide", () => {
            // Force unmount is necessary because the animation panel components
            // don't support slide/canvas change (for the sake of simplicity)
            this.renderAnimationPanel(true);
        });
    },

    renderContents: function() {
        this.$contents.css({
            zIndex: 0,
            padding: 0,
            overflow: "hidden",
            height: "100%"
        });
        this.$resizeBar.css({
            zIndex: 9999,
            background: "transparent",
            height: "2px"
        });

        // Force unmount is necessary here to ensure idempotency of renderContents();
        this.renderAnimationPanel(true);
    },

    onResize: function() {
        this.renderAnimationPanel(false);
    },

    renderAnimationPanel: function(forceUnmount) {
        if (forceUnmount && this.unmountAnimationPanel) {
            this.unmountAnimationPanel();
            this.unmountAnimationPanel = null;
        }

        this.unmountAnimationPanel = renderReactRoot(
            AnimationPanel,
            {
                canvas: this.editor.getCurrentSlide().canvas,
                isReadOnly: this.isReadOnly,
                dialogHeight: this.$el.height(),
                onClose: () => this.close()
            },
            this.$contents[0]
        );
    },

    close: function() {
        app.mainView.editorView.hideAnimationDialog(true);
    },

    onWindowKeydown: function(event) {
        if (event.which == Key.ESCAPE && !this.editor.isPresenting) {
            this.close();
        }
    },

    remove: function(...args) {
        if (this.unmountAnimationPanel) {
            this.unmountAnimationPanel();
            this.unmountAnimationPanel = null;
        }

        SideBar.prototype.remove.call(this, ...args);
    }
});
